var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "talent-filter-item" }, [
    _c("div", { staticClass: "talent-filter-item__content" }, [
      _c("div", { staticClass: "talent-filter-item__image" }, [
        _c("img", { attrs: { src: _vm.talent.profile_image_url } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "talent-filter-item__copy" }, [
        _c(
          "div",
          {},
          [
            _c(
              "router-link",
              {
                staticStyle: { "text-decoration": "underline" },
                attrs: {
                  tag: "a",
                  to: {
                    name: "talent.profile.view",
                    params: { id: _vm.talent.id, status: "event" },
                  },
                  target: "_blank",
                },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.talent.name))]),
                _vm._v(" "),
                _vm.talent.management && !_vm.$userIsManager
                  ? _c("i", {
                      staticClass: "fa fa-fw fa-group",
                      attrs: {
                        "aria-label": _vm.talent.management.company,
                        title: _vm.talent.management.company,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.talent.profile.visibility === "hidden" &&
                (_vm.$userIsAdmin || _vm.$userIsManager)
                  ? _c("i", {
                      staticClass: "fa fa-eye-slash",
                      attrs: { "aria-label": "hidden", title: "hidden" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.talent.profile.visibility === "private" &&
                (_vm.$userIsAdmin || _vm.$userIsManager)
                  ? _c("i", {
                      staticClass: "fa fa-lock",
                      attrs: { "aria-label": "private", title: "private" },
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.$showTalentStatsForClient ||
            _vm.$talentContractsModuleEnabled ||
            _vm.$userIsAdmin
              ? _c("div", [
                  _vm.talent.profile.tagline
                    ? _c(
                        "div",
                        {
                          staticClass: "tagline",
                          attrs: { title: _vm.talent.profile.tagline },
                        },
                        [_vm._v(_vm._s(_vm.talent.profile.tagline))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "talent-filter-item__details" },
                    [
                      _vm.canSeeEarnings
                        ? _c("p", { staticStyle: { color: "#5cb85c" } }, [
                            _vm._v(" " + _vm._s(_vm.engagements) + " "),
                            _c("i", { staticClass: "fa fa-fw fa-briefcase" }),
                            _vm._v("     " + _vm._s(_vm.earnings) + " "),
                            _c("i", { staticClass: "fa fa-fw fa-money" }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$talentContractsModuleEnabled
                        ? _c(
                            "div",
                            { staticClass: "talent-filter-item__contract" },
                            [
                              _vm.talent.contracts &&
                              _vm.talent.contracts.length
                                ? _c(
                                    "div",
                                    [
                                      _vm._l(
                                        _vm.talent.contracts[0]
                                          .user_requirement_values,
                                        function (requirement) {
                                          return _c(
                                            "span",
                                            { key: requirement.id },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(requirement.name) +
                                                  ": " +
                                                  _vm._s(requirement.value) +
                                                  _vm._s(
                                                    requirement.requirement_value
                                                      ? "/" +
                                                          requirement.requirement_value
                                                      : ""
                                                  )
                                              ),
                                              _c("br"),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "strong",
                                        {
                                          staticClass: "contract-name",
                                          attrs: {
                                            title: _vm.talent.contracts[0].name,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.talent.contracts[0].name
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "flex",
                                staticStyle: {
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                !_vm.$hideSocialMediaReferences &&
                                _vm.talent.profile.highest_followers &&
                                _vm.talent.total_earnings === undefined
                                  ? _c(
                                      "div",
                                      { attrs: { title: "Highest followers" } },
                                      [
                                        _c("i", {
                                          class:
                                            "fab " +
                                            _vm.talent.profile
                                              .highest_followers_icon,
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.talent.profile
                                                .highest_followers
                                            )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$vlastMode &&
                                _vm.talent.total_engagements !== undefined
                                  ? _c(
                                      "div",
                                      { attrs: { title: "Booking count" } },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-briefcase",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("nullable")(
                                                _vm.talent.total_engagements
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm.$vlastMode &&
                                    _vm.talent.talent_bookings_count !==
                                      undefined
                                  ? _c(
                                      "div",
                                      { attrs: { title: "Booking count" } },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-briefcase",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.talent.talent_bookings_count >
                                                0
                                                ? _vm.talent
                                                    .talent_bookings_count
                                                : "-"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.talent.total_earnings !== undefined
                                  ? _c(
                                      "div",
                                      {
                                        attrs: {
                                          title:
                                            _vm.talent.currency === "points"
                                              ? "Total points"
                                              : "Total earnings",
                                        },
                                      },
                                      [
                                        _vm.talent.currency &&
                                        _vm.talent.currency !== "points"
                                          ? _c("i", {
                                              staticClass: "fa fa-dollar",
                                            })
                                          : _c("i", {
                                              staticClass: "fa fa-check",
                                            }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("nullable")(
                                                _vm.talent.total_earnings
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.talent.total_completed_booking_time
                              ? _c("div", { attrs: { title: "Total time" } }, [
                                  _c("i", { staticClass: "fa fa-clock-o" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.talent.total_completed_booking_time
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                      _vm._v(" "),
                      _vm._l(_vm.talent.talent_key_metrics, function (metrics) {
                        return _vm.talent.talent_key_metrics
                          ? _c("div", { key: metrics.attribute }, [
                              metrics.value
                                ? _c(
                                    "div",
                                    { attrs: { title: metrics.title } },
                                    [
                                      _c("i", {
                                        staticClass: "fa",
                                        class: metrics.icon,
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(metrics.value) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$retired
              ? _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm._f("sentenceCase")(_vm.$t(_vm.talent.profile.retired))
                    )
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "talent-filter-item__cta" }, [
      _vm.canSetBudgetPerTalent && _vm.talentIsAlreadyAdded && _vm.bookingBudget
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.budget,
                expression: "budget",
              },
            ],
            domProps: { value: _vm.budget },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.budget = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.talentIsAlreadyAdded
        ? _c(
            "a",
            {
              staticClass: "btn btn-sm btn-success",
              on: {
                click: function ($event) {
                  return _vm.handleRemoveTalentCallback(_vm.talent)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-fw fa-check" })]
          )
        : _c(
            "a",
            {
              staticClass: "btn btn-sm btn-default",
              attrs: {
                disabled: _vm.hasLimit && _vm.selectedStars.length >= 10,
              },
              on: {
                click: function ($event) {
                  return _vm.handleAddTalentCallback(_vm.talent)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-fw fa-plus" })]
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }